module.exports = __webpack_public_path__ + "assets/img/service.24e86431.png";